<template>
  <div>
    <list-search-box v-model="form" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName" :default-sort="{ prop: 'createTime', order: 'descending' }" @sort-change="handelSortChange">
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="150">
          <template v-slot="{ row }">
            <span class="click-span" @click="jumpToContractDetails(row)">
              {{ row.projectName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" width="140" />
        <el-table-column prop="createTime" label="合同时间" align="left" min-width="90" sortable="custom" />
        <el-table-column prop="soldCountry" label="销往国家" align="left" min-width="90" />
        <el-table-column prop="departmentName" label="部门" align="left" min-width="90" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <!-- <contract-file-dialog ref="fileDialog" /> -->
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './ListSearchBox';
// import contractFileDialog from './ContractFileDialog';
import { getBGOrdersContractList } from '@/API/international.js';
export default {
  data () {
    return {
      form: {
        contractNum: '',
        // deptId: '',
        // userNo: '',
        projectName: '',
        soldCountry: '',
        startCreateTime: '',
        endCreateTime: '',
        orderDirection: 'DESC'
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    listSearchBox
    // contractFileDialog
  },
  computed: {
  },
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getBGOrdersContractList({
        ...this.form,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.$emit('totalNumber', this.page.total);
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    handelSortChange ({ prop, order }) {
      if (prop !== 'createTime') return;
      if (!order) {
        this.form.orderDirection = 'DESC';
      } else {
        this.form.orderDirection = order === 'ascending' ? 'ASC' : 'DESC';
      }
      this.page.currentPage = 1;
      this.doSearch();
    },
    jumpToContractDetails (params) {
      this.$router.push({
        name: 'sparePartsContractDetails',
        params: {
          contractNum: params.contractNum,
          contractType: '国际业务下单'
        },
        query: { id: params.id, isShowInternationalService: '0' }
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    godoIt (row) {
      this.$router.push({
        'name': 'businessHandler',
        params: {
          contractNum: row.contractNum,
          contractType: row.contractType
        },
        query: { isShowInternationalService: row.civilInternational }
      });
    },
    tableRowClassName ({ row }) {
      // if (row.salesType === 2) {
      //   return 'warning-row';
      // }
      // if (row.isHuaQiangFlag === 1) {
      //   return 'highlight-row';
      // }
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style>
  .el-table .warning-row {
    color: red;
  }
  .el-table .highlight-row {
    color: #67C23A;
  }
  .click-span {
    color: #409EFF;
  }
</style>
